import * as UserActionTypes from 'actiontypes/user';
import userService from 'services/UserService';
import { Dispatch } from 'redux';

const UserService = new userService();

export default function fetchUser() {
  return async (dispatch: Dispatch) => {
    dispatch(fetchUserRequested());
    try {
      const { data } = await UserService.fetchUser();
      dispatch(fetchUserSuccess(data));
      return data;
    } catch (error) {
      dispatch(fetchUserFailed(error));
    }
  };
}

const fetchUserSuccess = (data: any) => ({
  type: UserActionTypes.ALLOW_LOGIN_FROM_APP_SUCCESS,
  loggedIn: data.isSuccess,
});

const fetchUserRequested = () => ({
  type: UserActionTypes.ALLOW_LOGIN_FROM_APP_REQUESTED,
});

const fetchUserFailed = (error: any) => ({
  type: UserActionTypes.ALLOW_LOGIN_FROM_APP_FAILURE,
  status: error.response && error.response.status,
});